// @ts-check
import Vue from 'vue';
/**
 * Get default state for betslip messages
 */
const getDefaultState = () => ({
	messages: {},
	betBuilder: {},
});

export const messageStore = Vue.observable(getDefaultState());

/**
 * Clear message store
 */
export function resetMessageStore() {
	Object.assign(messageStore, getDefaultState());
}

/**
 * Add message to message store
 * @param {string} key - message key
 * @param {import('bto-models/betslip/interfaces').BetslipErrorMessage} msg - message object
 */
export function addBetslipMessage(key, msg) {
	Vue.set(messageStore.messages, key, msg);
}

/**
 * Add betbuilder message to message store
 * @param {number} key - match Id
 * @param {import('bto-models/betslip/interfaces').BetslipErrorMessage} msg - message object
 */
export function addBetBuilderMessage(key, msg) {
	Vue.set(messageStore.betBuilder, key, msg);
}

/**
 * Remore betbuilder message from store
 * @param {number} key - match Id
 */
export function removeBetBuilderMessage(key) {
	Vue.delete(messageStore.betBuilder, key);
}

/**
 * Remore message from store
 * @param {string} key - message to delete
 */
export function removeBetslipMessage(key) {
	Vue.delete(messageStore.messages, key);
}